export const volumes = [{
  n: 1,
  title: 'Daily Operations & Task Management',
  subtitle: 'The Daily Execution Framework',
  desc: 'Organize daily priorities, task assignments, recurring responsibilities, operational checklists, and follow-up routines. Use structured prompts to turn scattered information into clearer task lists and practical action plans.'
}, {
  n: 2,
  title: 'Team Communication & Delegation',
  subtitle: 'The Clear Communication Toolkit',
  desc: 'Prepare instructions, delegation messages, team updates, expectation-setting conversations, and professional follow-ups. Adapt the wording to your team’s context, responsibilities, and communication style.'
}, {
  n: 3,
  title: 'Professional Reports & Documentation',
  subtitle: 'The Reporting & Documentation System',
  desc: 'Structure activity summaries, operational updates, incident documentation, progress reports, and management communications. Organize the relevant facts before using AI to help prepare a clear first draft.'
}, {
  n: 4,
  title: 'Meetings, Briefings & Follow-Up',
  subtitle: 'The Team Coordination Framework',
  desc: 'Prepare meeting agendas, shift briefings, discussion points, meeting summaries, action lists, and follow-up messages. Make it easier to identify decisions, responsibilities, and next steps.'
}, {
  n: 5,
  title: 'Performance Tracking & Problem-Solving',
  subtitle: 'The Performance Review Toolkit',
  desc: 'Organize progress updates, task completion summaries, recurring issues, performance observations, and improvement opportunities. Use AI to help structure the information you provide and identify questions that may need further review.'
}, {
  n: 6,
  title: 'Planning, Process Improvement & Leadership',
  subtitle: 'The Supervisory Planning System',
  desc: 'Build weekly plans, prioritize competing responsibilities, organize workflow improvements, prepare coaching conversations, and structure action plans for recurring operational challenges.'
}];

export const volumeIncludes = [
  'Ready-to-use copy-and-paste AI prompts.',
  'Customizable placeholders for your specific situation.',
  'Clear instructions for adapting prompts to different supervisory tasks.',
  'Structured outputs to help organize information and next steps.',
  'Practical review points to help you check the accuracy, completeness, and relevance of AI-generated drafts.',
];

export const bonuses = [{
  n: '01',
  title: 'The Daily Supervisor Checklist Kit™',
  tagline: 'Turn recurring responsibilities into a clearer, more organized routine.',
  desc: 'Includes practical checklist structures for daily operations, task verification, team coordination, and follow-through. Adapt the checklists to your role, your team’s needs, and your organization’s procedures.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/rfCqa6pKwyK6ZKjaTrgrgS/Tableta_con_guia_de_prompts_de_IA_(1).webp'
}, {
  n: '02',
  title: 'The Professional Report Template Pack™',
  tagline: 'Prepare more structured reports and operational updates without designing every document from scratch.',
  desc: 'Use adaptable templates for activity summaries, management updates, progress documentation, and other recurring reporting needs.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/87XXy61mZuKEKRx5jzsPhT/Tableta_con_guia_de_prompts_de_IA_(2).webp'
}, {
  n: '03',
  title: 'The Team Meeting & Briefing Toolkit™',
  tagline: 'Make meetings and briefings more focused.',
  desc: 'Practical structures for agendas, team updates, meeting notes, action items, and follow-up responsibilities. Help organize the information participants need and clarify what should happen after the discussion.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/dMW3yZcwP2C4t7NuHPZDas/Tableta_con_guia_de_prompts_de_IA_(3).webp'
}, {
  n: '04',
  title: 'The AI Prompt Mastery Guide™',
  tagline: 'Get more consistent, relevant outputs from the prompts in your main toolkit.',
  desc: 'Learn how to provide clearer instructions to AI tools, include relevant context, define the desired output, and review the results before using them.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/w59vnCeL4ksSvNC5ziaVSU/Tableta_con_guia_de_prompts_de_IA_(4).webp'
}, {
  n: '05',
  title: 'The Weekly Planning & Priority Planner™',
  tagline: 'Create a clearer overview of upcoming responsibilities.',
  desc: 'Organize weekly priorities, recurring tasks, deadlines, and follow-up activities in a structured planning format, and identify where your attention is needed.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/sTPZq332LDnGAamkvBGCfT/Tableta_con_guia_de_prompts_de_IA_(5).webp'
}];
